import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookieService {

  setCookie(name: string, value: string, days: number = 30): void {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/;SameSite=Strict`;
  }

  getCookie(name: string): string | null {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  deleteCookie(name: string): void {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;SameSite=Strict`;
  }

  setNumberCookie(name: string, value: number, days: number = 30): void {
    this.setCookie(name, value.toString(), days);
  }

  getNumberCookie(name: string): number | null {
    const value = this.getCookie(name);
    if (value === null) return null;
    
    const parsed = parseInt(value, 10);
    return isNaN(parsed) ? null : parsed;
  }

  setJsonCookie<T>(name: string, value: T, days: number = 30): void {
    try {
      const jsonString = JSON.stringify(value);
      const encodedValue = encodeURIComponent(jsonString);
      this.setCookie(name, encodedValue, days);
    } catch (error) {
      console.error('Error setting JSON cookie:', error);
    }
  }

  getJsonCookie<T>(name: string): T | null {
    try {
      const value = this.getCookie(name);
      if (value === null) return null;
      
      const decodedValue = decodeURIComponent(value);
      return JSON.parse(decodedValue) as T;
    } catch (error) {
      console.error('Error parsing JSON cookie:', error);
      return null;
    }
  }
}